import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { LANGUAGES_QUERY } from '../graphql/queries'
import { COMMON_FETCH_LANGUAGES } from '../redux/action-types'
import { cleanupCommonFetchLanguages } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useLanguagesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchLanguages)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.languages,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        LANGUAGES_QUERY,
        {},
        dispatch,
        COMMON_FETCH_LANGUAGES,
      ),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useLanguagesQuery
